import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: routes.SETTINGS,
    name: 'SETTINGS',
    component: () => import('./SettingsShellPage.vue'),
    meta: { requiresAuth: true },
    redirect: routes.SETTINGS_GENERAL,
    children: [
      {
        path: 'general',
        name: 'SETTINGS_GENERAL',
        component: () => import('./general/containers/GeneralSettingsContainer.vue'),
      },
      {
        path: 'system-configuration',
        name: 'SETTINGS_SYSTEM_CONFIG',
        component: () => import('./systemConfig/containers/SystemConfigContainer.vue'),
      },
      {
        path: 'platform-settings',
        name: 'PLATFORM_SETTINGS',
        component: () => import('./platformSettings/containers/PlatformSettingsContainer.vue'),
      },
      {
        path: routes.SETTINGS_FEE_CONFIGURATION,
        name: 'FEE_CONFIGURATION',
        component: () => import('./feeConfig/containers/FeeConfigContainer.vue'),
      },
      {
        path: 'market-settings',
        name: 'MARKET_SETTINGS',
        component: () => import('./marketSettings/containers/MarketSettingsContainer.vue'),
      },
      {
        path: 'property-settings',
        name: 'PROPERTY_SETTINGS',
        component: () => import('./propertySettings/containers/PropertySettingsContainer.vue'),
      },
      {
        path: 'property-type-media-settings',
        name: 'PROPERTY_TYPE_MEDIA_SETTINGS',
        component: () =>
          import('./propertyTypeMediaSettings/containers/PropertyTypeMediaSettingsContainer.vue'),
      },
    ],
  },
]
